<template lang="pug">
  shListData(title="Images History" resolver="imagesHistory" keyData="_id" component="shImage" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ImagesHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/image/ImagesHistory.vue